import { render, staticRenderFns } from "./EmailTemplateList.vue?vue&type=template&id=f8cae7b2&scoped=true&"
import script from "./EmailTemplateList.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateList.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplateList.vue?vue&type=style&index=0&id=f8cae7b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cae7b2",
  null
  
)

export default component.exports